export const LEGACY_AMENITY_CODES = [
    '24-hour-check-in',
    '24-hour-front-desk',
    '24-hour-security',
    'accessible-parking',
    'access-to-healthcare-professionals',
    'aerobics',
    'air-conditioning',
    'airport-shuttle',
    'all-inclusive-meals',
    'all-rooms-disinfected-daily',
    'archery',
    'atm-on-site',
    'audio-visual-equipment-rental',
    'auditory-guidance',
    'baby-safety-gates',
    'babysitting-child-services',
    'badminton',
    'baggage-storage',
    'banquet-rooms',
    'bar',
    'bar-crawls',
    'bathhouse',
    'bathroom-emergency-pull-cord',
    'bbq-facilities',
    'beach',
    'beach-chairs-loungers',
    'beachfront',
    'beach-umbrellas',
    'beauty-services',
    'bicycle-rental',
    'bike-tours',
    'billiards-pool-table',
    'bingo',
    'board-games-puzzles',
    'boating',
    'body-thermometer',
    'books-dvds-music-for-kids',
    'bottled-water',
    'bowling',
    'breakfast-buffet',
    'breakfast-in-the-room',
    'breakfast-takeaway-containers',
    'business-center',
    'buzzer-wireless-intercom',
    'canoeing',
    'carbon-monoxide-detector',
    'carbon-monoxide-sources',
    'car-for-hire',
    'car-rental',
    'cashless-payment-accepted',
    'casino',
    'cctv-in-common-areas',
    'cctv-outside-property',
    'chapel',
    'childrens-club',
    'chocolate-cookies',
    'cleaning-chemicals-used-are-effective-agaist-covid',
    'coffee-shop',
    'common-areas-disinfected-daily',
    'common-stationery-removed',
    'concierge',
    'contactless-check-in-check-out',
    'breakfast-continental',
    'cooking-class',
    'couples-only',
    'cycling',
    'daily-housekeeping',
    'darts',
    'delivered-food-covered-securely',
    'designated-smoking-area',
    'diving',
    'doorman',
    'dry-cleaning',
    'electric-vehicle-charging-station',
    'elevator',
    'entertainment-staff',
    'evening-entertainment',
    'express-check-in-check-out',
    'exterior-corridor',
    'face-masks-available-for-guests',
    'face-masks-on-staff',
    'facilities-for-disabled-guests',
    'family-rooms',
    'fax-services',
    'fire-extinguishers',
    'fireplace',
    'first-aid-kits',
    'fishing',
    'fitness-center',
    'food-can-be-delivered-for-in-room-dining',
    'food-delivery',
    'foot-bath',
    'foreign-currency-exchange',
    'breakfast-free',
    'fruit',
    'game-room',
    'garden',
    'gift-shop',
    'golf-course-on-site',
    'golf-course-within-3-5-km-2-mi',
    'grocery-deliveries',
    'guest-accommodations-disinfected-between-stays',
    'guest-accommodations-sealed-after-cleaning',
    'guest-accommodation-cleaning-can-be-cancelled',
    'guest-health-checks',
    'guest-parking',
    'guests-can-opt-out-of-daily-room-cleaning',
    'hair-beauty-salon',
    'restaurant-halal',
    'hand-sanitizer-provided',
    'happy-hour',
    'heating',
    'hiking',
    'honeymoon-bridal-suite',
    'horseback-riding',
    'hot-spring-bath',
    'hot-tub',
    'hygiene-certification',
    'hypoallergenic-rooms',
    'indoor-play-area',
    'infirmary',
    'internet',
    'invoices',
    'ironing-service',
    'karaoke',
    'key-card-or-motion-controlled-electricity',
    'kid-friendly-buffet',
    'kids-club',
    'kids-meals',
    'kids-tv-channels',
    'restaurant-kosher',
    'laundry-service',
    'library',
    'linens-towels-laundry-washed-per-local-authority-guidelines',
    'live-music-performance',
    'live-sports-events-broadcast',
    'local-safety-protocols-followed',
    'locker-rooms',
    'lockers',
    'lounge',
    'low-bathroom-sink',
    'massage',
    'massage-chair',
    'meeting-rooms',
    'miniature-golf',
    'minimarket-convenience-store',
    'mobile-app-for-room-service',
    'movie-nights',
    'newspapers',
    'nightclub-dj',
    'no-children-allowed',
    'non-smoking-rooms',
    'open-air-bath',
    'fireplace-outdoor',
    'outdoor-furniture',
    'outdoor-play-equipment',
    'personal-trainer',
    'photocopying-services',
    'physical-distancing-in-dining-areas',
    'physical-distancing-rules',
    'picnic-area',
    'playground',
    'pool-beach-towels',
    'portable-wi-fi-device-rental',
    'postal-service',
    'prepared-lunches',
    'printer',
    'beach-area-private',
    'private-check-in-check-out',
    'property-cleaned-by-professional-cleaning-companies',
    'property-has-wheelchair-access',
    'public-transit-tickets',
    'racquetball-squash',
    'raised-toilet',
    'refillable-water-stations',
    'restaurant',
    'room-service',
    'safety-deposit-box',
    'safe-deposit-boxes-at-front-desk',
    'sanitized-tableware',
    'sauna',
    'screens-between-staff-guests-where-needed',
    'security-alarm',
    'self-service-laundry',
    'shared-kitchen',
    'shared-lounge-tv-area',
    'shoeshine',
    'shops-on-site',
    'shrine',
    'shuttle-service',
    'single-use-plastics-removed',
    'ski-equipment-rental',
    'skiing',
    'ski-school',
    'smoke-alarms',
    'smoke-free-property',
    'snack-bar',
    'snorkeling',
    'solarium',
    'soundproof-rooms',
    'spa',
    'special-diet-meals-on-request',
    'stand-up-comedy',
    'steam-room',
    'sterilizing-equipment',
    'strollers',
    'suit-trouser-press',
    'sun-deck',
    'surfing-lessons',
    'swimming-pool',
    'table-tennis-ping-pong',
    'taxi-service',
    'temperature-check-for-guests-and-staff',
    'temporary-art-galleries',
    'tennis-court',
    'terrace',
    'themed-dinners',
    'theme-park',
    'thermometers-for-guests',
    'ticketing-service',
    'toilet-with-grab-rails',
    'tour-assistance',
    'tours',
    'towels-changed-upon-request',
    'turkish-steam-bath',
    'room-service-24-hours',
    'valet-parking',
    'valet-service',
    'vending-machine-drinks',
    'vending-machine-snacks',
    'vending-machines-contents-unspecified',
    'vip-room-facilities',
    'visual-aids-braille',
    'visual-aids-tactile-signs',
    'walking-tours',
    'water-park',
    'waterslide',
    'water-sports-equipment-rental',
    'water-sports-motorized',
    'water-sports-non-motorized',
    'welcome-drink',
    'windsurfing',
    'wine-champagne',
    'yoga',
];
// Maps each legacy amenity code to its category
export const LEGACY_AMENITY_CATEGORY_MAP = new Map([
    // accessibility
    ['accessible-parking', 'accessibility'],
    ['auditory-guidance', 'accessibility'],
    ['bathroom-emergency-pull-cord', 'accessibility'],
    ['facilities-for-disabled-guests', 'accessibility'],
    ['low-bathroom-sink', 'accessibility'],
    ['property-has-wheelchair-access', 'accessibility'],
    ['raised-toilet', 'accessibility'],
    ['toilet-with-grab-rails', 'accessibility'],
    ['visual-aids-braille', 'accessibility'],
    ['visual-aids-tactile-signs', 'accessibility'],
    // business-services
    ['audio-visual-equipment-rental', 'business-services'],
    ['banquet-rooms', 'business-services'],
    ['business-center', 'business-services'],
    ['fax-services', 'business-services'],
    ['meeting-rooms', 'business-services'],
    ['photocopying-services', 'business-services'],
    ['portable-wi-fi-device-rental', 'business-services'],
    ['postal-service', 'business-services'],
    ['printer', 'business-services'],
    // check-in-front-desk-services
    ['24-hour-check-in', 'check-in-front-desk-services'],
    ['24-hour-front-desk', 'check-in-front-desk-services'],
    ['contactless-check-in-check-out', 'check-in-front-desk-services'],
    ['express-check-in-check-out', 'check-in-front-desk-services'],
    ['invoices', 'check-in-front-desk-services'],
    ['private-check-in-check-out', 'check-in-front-desk-services'],
    // cleaning-services
    ['daily-housekeeping', 'cleaning-services'],
    ['dry-cleaning', 'cleaning-services'],
    ['ironing-service', 'cleaning-services'],
    ['laundry-service', 'cleaning-services'],
    ['self-service-laundry', 'cleaning-services'],
    ['shoeshine', 'cleaning-services'],
    ['suit-trouser-press', 'cleaning-services'],
    // common-areas
    ['chapel', 'common-areas'],
    ['exterior-corridor', 'common-areas'],
    ['fireplace', 'common-areas'],
    ['fireplace-outdoor', 'common-areas'],
    ['game-room', 'common-areas'],
    ['garden', 'common-areas'],
    ['library', 'common-areas'],
    ['lounge', 'common-areas'],
    ['outdoor-furniture', 'common-areas'],
    ['picnic-area', 'common-areas'],
    ['shared-kitchen', 'common-areas'],
    ['shared-lounge-tv-area', 'common-areas'],
    ['shrine', 'common-areas'],
    ['sun-deck', 'common-areas'],
    ['terrace', 'common-areas'],
    // entertainment-recreation
    ['aerobics', 'entertainment-recreation'],
    ['archery', 'entertainment-recreation'],
    ['badminton', 'entertainment-recreation'],
    ['bar-crawls', 'entertainment-recreation'],
    ['beach', 'entertainment-recreation'],
    ['beach-area-private', 'entertainment-recreation'],
    ['beachfront', 'entertainment-recreation'],
    ['bike-tours', 'entertainment-recreation'],
    ['billiards-pool-table', 'entertainment-recreation'],
    ['bingo', 'entertainment-recreation'],
    ['boating', 'entertainment-recreation'],
    ['bowling', 'entertainment-recreation'],
    ['canoeing', 'entertainment-recreation'],
    ['casino', 'entertainment-recreation'],
    ['cooking-class', 'entertainment-recreation'],
    ['cycling', 'entertainment-recreation'],
    ['darts', 'entertainment-recreation'],
    ['diving', 'entertainment-recreation'],
    ['entertainment-staff', 'entertainment-recreation'],
    ['evening-entertainment', 'entertainment-recreation'],
    ['fishing', 'entertainment-recreation'],
    ['golf-course-on-site', 'entertainment-recreation'],
    ['golf-course-within-3-5-km-2-mi', 'entertainment-recreation'],
    ['happy-hour', 'entertainment-recreation'],
    ['hiking', 'entertainment-recreation'],
    ['horseback-riding', 'entertainment-recreation'],
    ['karaoke', 'entertainment-recreation'],
    ['live-music-performance', 'entertainment-recreation'],
    ['live-sports-events-broadcast', 'entertainment-recreation'],
    ['movie-nights', 'entertainment-recreation'],
    ['nightclub-dj', 'entertainment-recreation'],
    ['miniature-golf', 'entertainment-recreation'],
    ['racquetball-squash', 'entertainment-recreation'],
    ['ski-equipment-rental', 'entertainment-recreation'],
    ['ski-school', 'entertainment-recreation'],
    ['skiing', 'entertainment-recreation'],
    ['snorkeling', 'entertainment-recreation'],
    ['stand-up-comedy', 'entertainment-recreation'],
    ['surfing-lessons', 'entertainment-recreation'],
    ['table-tennis-ping-pong', 'entertainment-recreation'],
    ['temporary-art-galleries', 'entertainment-recreation'],
    ['tennis-court', 'entertainment-recreation'],
    ['theme-park', 'entertainment-recreation'],
    ['themed-dinners', 'entertainment-recreation'],
    ['tours', 'entertainment-recreation'],
    ['water-park', 'entertainment-recreation'],
    ['water-sports-equipment-rental', 'entertainment-recreation'],
    ['water-sports-motorized', 'entertainment-recreation'],
    ['water-sports-non-motorized', 'entertainment-recreation'],
    // environment-sustainability
    ['guests-can-opt-out-of-daily-room-cleaning', 'environment-sustainability'],
    ['key-card-or-motion-controlled-electricity', 'environment-sustainability'],
    ['refillable-water-stations', 'environment-sustainability'],
    ['single-use-plastics-removed', 'environment-sustainability'],
    ['towels-changed-upon-request', 'environment-sustainability'],
    // family-services-activities
    ['babysitting-child-services', 'family-services-activities'],
    ['board-games-puzzles', 'family-services-activities'],
    ['books-dvds-music-for-kids', 'family-services-activities'],
    ['childrens-club', 'family-services-activities'],
    ['family-rooms', 'family-services-activities'],
    ['indoor-play-area', 'family-services-activities'],
    ['kids-club', 'family-services-activities'],
    ['kids-tv-channels', 'family-services-activities'],
    ['no-children-allowed', 'family-services-activities'],
    ['outdoor-play-equipment', 'family-services-activities'],
    ['playground', 'family-services-activities'],
    ['strollers', 'family-services-activities'],
    // food-beverage
    ['all-inclusive-meals', 'food-beverage'],
    ['bar', 'food-beverage'],
    ['bbq-facilities', 'food-beverage'],
    ['bottled-water', 'food-beverage'],
    ['breakfast-buffet', 'food-beverage'],
    ['breakfast-continental', 'food-beverage'],
    ['breakfast-free', 'food-beverage'],
    ['breakfast-in-the-room', 'food-beverage'],
    ['chocolate-cookies', 'food-beverage'],
    ['coffee-shop', 'food-beverage'],
    ['food-delivery', 'food-beverage'],
    ['fruit', 'food-beverage'],
    ['grocery-deliveries', 'food-beverage'],
    ['kid-friendly-buffet', 'food-beverage'],
    ['kids-meals', 'food-beverage'],
    ['prepared-lunches', 'food-beverage'],
    ['restaurant', 'food-beverage'],
    ['restaurant-halal', 'food-beverage'],
    ['restaurant-kosher', 'food-beverage'],
    ['room-service', 'food-beverage'],
    ['snack-bar', 'food-beverage'],
    ['special-diet-meals-on-request', 'food-beverage'],
    ['vending-machine-drinks', 'food-beverage'],
    ['vending-machine-snacks', 'food-beverage'],
    ['vending-machines-contents-unspecified', 'food-beverage'],
    ['welcome-drink', 'food-beverage'],
    ['wine-champagne', 'food-beverage'],
    // general-guest-services
    ['air-conditioning', 'general-guest-services'],
    ['atm-on-site', 'general-guest-services'],
    ['baggage-storage', 'general-guest-services'],
    ['concierge', 'general-guest-services'],
    ['couples-only', 'general-guest-services'],
    ['designated-smoking-area', 'general-guest-services'],
    ['elevator', 'general-guest-services'],
    ['foreign-currency-exchange', 'general-guest-services'],
    ['heating', 'general-guest-services'],
    ['honeymoon-bridal-suite', 'general-guest-services'],
    ['hypoallergenic-rooms', 'general-guest-services'],
    ['internet', 'general-guest-services'],
    ['lockers', 'general-guest-services'],
    ['newspapers', 'general-guest-services'],
    ['non-smoking-rooms', 'general-guest-services'],
    ['room-service-24-hours', 'general-guest-services'],
    ['safe-deposit-boxes-at-front-desk', 'general-guest-services'],
    ['safety-deposit-box', 'general-guest-services'],
    ['smoke-free-property', 'general-guest-services'],
    ['soundproof-rooms', 'general-guest-services'],
    ['ticketing-service', 'general-guest-services'],
    ['tour-assistance', 'general-guest-services'],
    ['valet-service', 'general-guest-services'],
    ['vip-room-facilities', 'general-guest-services'],
    ['walking-tours', 'general-guest-services'],
    // parking-transportation
    ['airport-shuttle', 'parking-transportation'],
    ['baby-safety-gates', 'parking-transportation'],
    ['bicycle-rental', 'parking-transportation'],
    ['car-for-hire', 'parking-transportation'],
    ['car-rental', 'parking-transportation'],
    ['electric-vehicle-charging-station', 'parking-transportation'],
    ['guest-parking', 'parking-transportation'],
    ['public-transit-tickets', 'parking-transportation'],
    ['shuttle-service', 'parking-transportation'],
    ['taxi-service', 'parking-transportation'],
    ['valet-parking', 'parking-transportation'],
    // pool-spa-wellness
    ['bathhouse', 'pool-spa-wellness'],
    ['beach-chairs-loungers', 'pool-spa-wellness'],
    ['beach-umbrellas', 'pool-spa-wellness'],
    ['beauty-services', 'pool-spa-wellness'],
    ['fitness-center', 'pool-spa-wellness'],
    ['foot-bath', 'pool-spa-wellness'],
    ['hot-spring-bath', 'pool-spa-wellness'],
    ['hot-tub', 'pool-spa-wellness'],
    ['locker-rooms', 'pool-spa-wellness'],
    ['massage', 'pool-spa-wellness'],
    ['massage-chair', 'pool-spa-wellness'],
    ['open-air-bath', 'pool-spa-wellness'],
    ['pool-beach-towels', 'pool-spa-wellness'],
    ['sauna', 'pool-spa-wellness'],
    ['solarium', 'pool-spa-wellness'],
    ['spa', 'pool-spa-wellness'],
    ['steam-room', 'pool-spa-wellness'],
    ['swimming-pool', 'pool-spa-wellness'],
    ['turkish-steam-bath', 'pool-spa-wellness'],
    ['waterslide', 'pool-spa-wellness'],
    ['yoga', 'pool-spa-wellness'],
    ['personal-trainer', 'pool-spa-wellness'],
    // safety-security
    ['24-hour-security', 'safety-security'],
    ['buzzer-wireless-intercom', 'safety-security'],
    ['carbon-monoxide-detector', 'safety-security'],
    ['carbon-monoxide-sources', 'safety-security'],
    ['cctv-in-common-areas', 'safety-security'],
    ['cctv-outside-property', 'safety-security'],
    ['doorman', 'safety-security'],
    ['fire-extinguishers', 'safety-security'],
    ['security-alarm', 'safety-security'],
    ['smoke-alarms', 'safety-security'],
    // sanitation-hygiene-guest-health
    ['access-to-healthcare-professionals', 'sanitation-hygiene-guest-health'],
    ['all-rooms-disinfected-daily', 'sanitation-hygiene-guest-health'],
    ['body-thermometer', 'sanitation-hygiene-guest-health'],
    ['breakfast-takeaway-containers', 'sanitation-hygiene-guest-health'],
    ['cashless-payment-accepted', 'sanitation-hygiene-guest-health'],
    ['common-areas-disinfected-daily', 'sanitation-hygiene-guest-health'],
    ['common-stationery-removed', 'sanitation-hygiene-guest-health'],
    ['delivered-food-covered-securely', 'sanitation-hygiene-guest-health'],
    ['face-masks-available-for-guests', 'sanitation-hygiene-guest-health'],
    ['face-masks-on-staff', 'sanitation-hygiene-guest-health'],
    ['first-aid-kits', 'sanitation-hygiene-guest-health'],
    [
        'food-can-be-delivered-for-in-room-dining',
        'sanitation-hygiene-guest-health',
    ],
    [
        'guest-accommodation-cleaning-can-be-cancelled',
        'sanitation-hygiene-guest-health',
    ],
    [
        'guest-accommodations-disinfected-between-stays',
        'sanitation-hygiene-guest-health',
    ],
    [
        'guest-accommodations-sealed-after-cleaning',
        'sanitation-hygiene-guest-health',
    ],
    ['guest-health-checks', 'sanitation-hygiene-guest-health'],
    ['hand-sanitizer-provided', 'sanitation-hygiene-guest-health'],
    ['hygiene-certification', 'sanitation-hygiene-guest-health'],
    ['infirmary', 'sanitation-hygiene-guest-health'],
    [
        'linens-towels-laundry-washed-per-local-authority-guidelines',
        'sanitation-hygiene-guest-health',
    ],
    ['local-safety-protocols-followed', 'sanitation-hygiene-guest-health'],
    ['mobile-app-for-room-service', 'sanitation-hygiene-guest-health'],
    ['physical-distancing-in-dining-areas', 'sanitation-hygiene-guest-health'],
    ['physical-distancing-rules', 'sanitation-hygiene-guest-health'],
    [
        'property-cleaned-by-professional-cleaning-companies',
        'sanitation-hygiene-guest-health',
    ],
    ['sanitized-tableware', 'sanitation-hygiene-guest-health'],
    [
        'screens-between-staff-guests-where-needed',
        'sanitation-hygiene-guest-health',
    ],
    ['sterilizing-equipment', 'sanitation-hygiene-guest-health'],
    ['temperature-check-for-guests-and-staff', 'sanitation-hygiene-guest-health'],
    ['thermometers-for-guests', 'sanitation-hygiene-guest-health'],
    [
        'cleaning-chemicals-used-are-effective-agaist-covid',
        'sanitation-hygiene-guest-health',
    ],
    // shopping
    ['gift-shop', 'shopping'],
    ['hair-beauty-salon', 'shopping'],
    ['minimarket-convenience-store', 'shopping'],
    ['shops-on-site', 'shopping'],
]);
